module.exports = __webpack_public_path__ + "img/checkMarkDodIcon.37b1b330.svg";